import React, { createContext, useState } from 'react';
import Accordance from '../../../../../models/Accordance';
import { AccordanceType } from '../../../../../models/AccordanceType';

type InitialStateType = {
  bundleAccordances: any[];
  possibleActionsList: any[];
  supervisionActionList: any;
  accordanceFormType: AccordanceType;
  relatedAccordance: Accordance | null;
  accordanceChanged: boolean
};

export const initialState = {
  bundleAccordances: [],
  possibleActionsList: [],
  supervisionActionList: [],
  accordanceFormType: AccordanceType.Revision,
  relatedAccordance: null,
  accordanceChanged: false,
};

const NewAccordanceContext = createContext<{ state: InitialStateType; setState: Function; setAlertConfig?: Function }>({
  state: initialState,
  setState: () => {},
  setAlertConfig: undefined,
});

const NewAccordanceContextProvider = props => {
  const [state, setState] = useState(initialState);
  return (
    <NewAccordanceContext.Provider value={{ state, setState, setAlertConfig: props.setAlertConfig }}>
      {props.children}
    </NewAccordanceContext.Provider>
  );
};

export { NewAccordanceContextProvider, NewAccordanceContext };
